module.exports = __webpack_public_path__ + "img/video_link_test_arranged_icon.734b3ac9.svg";